const V4_API_SERVER = 'https://com4.zhxy365.cn'

//V4接口
export const V4_URL = {
    getSlideCode: V4_API_SERVER + '/api/services/common/code/getslidecode', //获取滑动验证码
    checkSlideCode: V4_API_SERVER + '/api/services/common/code/chkslidecode', //校验滑动验证码
}



// WEBPACK FOOTER //
// ./src/config/api.js